import React from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// jQuery 3.5+ removed $.camelCase; OwlCarousel2 still calls it.
const __camelCase = (v) => v.replace(/-([a-z])/g, (_, l) => l.toUpperCase());
if (typeof $.camelCase !== 'function') { $.camelCase = __camelCase; }

const CHUNK_RELOAD_SESSION_KEY = 'skyland_chunk_reload_once';

if (typeof window !== 'undefined') {
  // react-owl-carousel's UMD build expects window.jQuery/window.$.
  window.jQuery = window.jQuery || $;
  window.$ = window.$ || window.jQuery;
  if (window.jQuery && typeof window.jQuery.camelCase !== 'function') {
    window.jQuery.camelCase = __camelCase;
  }

  const isChunkLoadError = (value) => {
    const message = typeof value === 'string' ? value : value?.message || '';
    return /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
      message
    );
  };

  const reloadForChunkError = () => {
    try {
      if (window.sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1') {
        return;
      }
      window.sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
    } catch (_error) {
      return;
    }

    window.location.reload();
  };

  if (!window.__skylandChunkRecoveryBound) {
    window.__skylandChunkRecoveryBound = true;

    window.addEventListener(
      'error',
      (event) => {
        if (isChunkLoadError(event?.message)) {
          reloadForChunkError();
          return;
        }

        const scriptSource = event?.target?.src || '';
        if (typeof scriptSource === 'string' && /\/static\/js\/.+\.chunk\.js/i.test(scriptSource)) {
          reloadForChunkError();
        }
      },
      true
    );

    window.addEventListener('unhandledrejection', (event) => {
      if (isChunkLoadError(event?.reason)) {
        reloadForChunkError();
      }
    });

    window.addEventListener(
      'load',
      () => {
        try {
          window.sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
        } catch (_error) {
          // Ignore storage access failures in private mode.
        }
      },
      { once: true }
    );
  }
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
